/**
 * Spacing tokens — Tailwind class fragments for rhythm across the shell.
 * Use for stack gaps, section spacing, card padding, and horizontal inset.
 *
 * WI-3 §4 — canonical rhythm. All card/section spacing snaps to the
 * **4 / 8 / 12 / 16 / 24 / 32** grid (Tailwind `1 / 2 / 3 / 4 / 6 / 8`).
 * Off-grid values like `*-2.5` (10px) and `*-3.5` (14px) are banned in card
 * surfaces; consume the tokens below (or their on-grid Tailwind equivalents)
 * rather than introducing new numeric literals. No new spacing values are
 * required — the rhythm is already fully tokenized here.
 */
export const spacing = {
  /** Vertical gaps between siblings in a flex/grid stack */
  stack: {
    xs: 'gap-1',
    sm: 'gap-1.5',
    md: 'gap-2',
    lg: 'gap-3',
    xl: 'gap-4',
    responsive: 'gap-1.5 md:gap-2',
  },
  /** Vertical spacing between major sections */
  section: {
    sm: 'space-y-3',
    md: 'space-y-5',
  },
  /** Card / panel interior padding */
  card: {
    sm: 'p-3 md:p-4',
    md: 'p-6 md:p-7',
    lg: 'p-8 md:p-10',
  },
  /** Modal body / footer padding */
  modal: {
    body: 'p-6',
    bodyLg: 'p-6 md:p-8',
    footer: 'p-6 pb-[max(1rem,env(safe-area-inset-bottom))]',
  },
  /** Horizontal inset for labels inside scroll rows */
  inset: {
    xs: 'px-1',
    sm: 'px-3',
    md: 'px-4',
  },
  /** Small margins below section labels */
  label: {
    below: 'mb-2',
    belowMd: 'mb-2 md:mb-3',
  },
  /** PWA touch-friendly gaps */
  touch: {
    stack: 'gap-3',
    section: 'space-y-4',
    inset: 'px-4',
  },
};
